export default __webpack_public_path__ + "static/media/celebration.f44a8ba0.png";